/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLeftRight = createReactComponent("arrow-left-right", "IconArrowLeftRight", [
  ["path", { d: "M17 13l4 -4l-4 -4", key: "svg-0" }],
  ["path", { d: "M7 13l-4 -4l4 -4", key: "svg-1" }],
  ["path", { d: "M12 14a5 5 0 0 1 5 -5h4", key: "svg-2" }],
  ["path", { d: "M12 19v-5a5 5 0 0 0 -5 -5h-4", key: "svg-3" }]
]);

export { IconArrowLeftRight as default };
//# sourceMappingURL=IconArrowLeftRight.js.map
